var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"whatsapp-float",attrs:{"href":_vm.whatsappUrl,"target":"_blank"}},[_c('i',{staticClass:"whatsapp-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }